export const medicaidFormSections = [
  {
    id: 1,
    name: 'Basic Details',
    fields: [
      {
        id: 'firstName',
        label: 'First Name',
        type: 'text',
        control_name: 'first_name',
        required: true,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'middleName',
        label: 'Middle Name',
        type: 'text',
        control_name: 'middle_name_initials',
        required: false,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'lastName',
        label: 'Last Name',
        type: 'text',
        control_name: 'last_name',
        required: true,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'date_of_birth',
        label: 'Date of Birth(MM/DD/YYYY)',
        type: 'datepicker',
        control_name: 'date_of_birth',
        required: true
      },
      {
        id: 'gender',
        label: 'Gender',
        type: 'select',
        control_name: 'gender',
        required: true,
        options: [
          { key: 'Male', value: 'Male' },
          { key: 'Female', value: 'Female' }
        ]
      },
    ]
  },
  {
    id: 2,
    name: 'Contact Details',
    fields: [
      {
        id: 'extra7',
        label: 'Primary Phone Number',
        type: 'text',
        control_name: 'extra7',
        required: true,
        maxlength: 12,
        pattern: '^\\d{3}-\\d{3}-\\d{4}$'
      },
      {
        id: 'phone_mobile',
        label: 'Alternate Phone Number',
        type: 'text',
        control_name: 'phone_mobile',
        required: false,
        maxlength: 12,
        pattern: '^\\d{3}-\\d{3}-\\d{4}$'
      },
      {
        id: 'email',
        label: 'Email Address',
        type: 'text',
        control_name: 'email',
        required: true,
        maxlength: 100,
        pattern: '^[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}$'
      },
    ]
  },
  {
    id: 3,
    name: 'Home Address',
    fields: [
      {
        id: 'home_street',
        label: 'Address',
        type: 'longtext',
        control_name: 'home_street',
        required: true,
        maxlength: 200,
        pattern: '^.*$'
      },
      {
        id: 'home_city',
        label: 'City',
        type: 'text',
        control_name: 'home_city',
        required: true,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'home_state',
        label: 'State',
        type: 'select',
        control_name: 'home_state',
        options: [
        {
            key: "AL",
            value: "AL",
        },
        {
            key: "AK",
            value: "AK",
        },
        {
            key: "AZ",
            value: "AZ",
        },
        {
            key: "AR",
            value: "AR",
        },
        {
            key: "CA",
            value: "CA",
        },
        {
            key: "CO",
            value: "CO",
        },
        {
            key: "CT",
            value: "CT",
        },
        {
            key: "DE",
            value: "DE",
        },
        {
            key: "FL",
            value: "FL",
        },
        {
            key: "GA",
            value: "GA",
        },
        {
            key: "HI",
            value: "HI",
        },
        {
            key: "ID",
            value: "ID",
        },
        {
            key: "IL",
            value: "IL",
        },
        {
            key: "IN",
            value: "IN",
        },
        {
            key: "IA",
            value: "IA",
        },
        {
            key: "KS",
            value: "KS",
        },
        {
            key: "KY",
            value: "KY",
        },
        {
            key: "LA",
            value: "LA",
        },
        {
            key: "ME",
            value: "ME",
        },
        {
            key: "MD",
            value: "MD",
        },
        {
            key: "MA",
            value: "MA",
        },
        {
            key: "MI",
            value: "MI",
        },
        {
            key: "MN",
            value: "MN",
        },
        {
            key: "MS",
            value: "MS",
        },
        {
            key: "MO",
            value: "MO",
        },
        {
            key: "MT",
            value: "MT",
        },
        {
            key: "NE",
            value: "NE",
        },
        {
            key: "NV",
            value: "NV",
        },
        {
            key: "NH",
            value: "NH",
        },
        {
            key: "NJ",
            value: "NJ",
        },
        {
            key: "NY",
            value: "NY",
        },
        {
            key: "NM",
            value: "NM",
        },
        {
            key: "NC",
            value: "NC",
        },
        {
            key: "ND",
            value: "ND",
        },
        {
            key: "OH",
            value: "OH",
        },
        {
            key: "OK",
            value: "OK",
        },
        {
            key: "OR",
            value: "OR",
        },
        {
            key: "PA",
            value: "PA",
        },
        {
            key: "RI",
            value: "RI",
        },
        {
            key: "SC",
            value: "SC",
        },
        {
            key: "SD",
            value: "SD",
        },
        {
            key: "TN",
            value: "TN",
        },
        {
            key: "TX",
            value: "TX",
        },
        {
            key: "UT",
            value: "UT",
        },
        {
            key: "VT",
            value: "VT",
        },
        {
            key: "WA",
            value: "WA",
        },
        {
            key: "WV",
            value: "WV",
        },
        {
            key: "WI",
            value: "WI",
        },
        {
            key: "WY",
            value: "WY",
        }
        ],
        required: true
      },
      {
        id: 'home_postcode',
        label: 'Zipcode',
        type: 'text',
        control_name: 'home_postcode',
        required: true,
        maxlength: 5,
        pattern: '^[0-9]+$'
      }
    ]
  },
  {
    id: 4,
    name: 'Mailing Address',
    fields: [
      {
        id: 'mailing_street',
        label: 'Address',
        type: 'longtext',
        control_name: 'mailing_street',
        required: false,
        maxlength: 200,
        pattern: '^.*$'
      },
      {
        id: 'mailing_city',
        label: 'City',
        type: 'text',
        control_name: 'mailing_city',
        required: false,
        maxlength: 100,
        pattern: '^.*$'
      },
      {
        id: 'mailing_state',
        label: 'State',
        type: 'select',
        control_name: 'mailing_state',
        options: [
        {
            key: "AL",
            value: "AL",
        },
        {
            key: "AK",
            value: "AK",
        },
        {
            key: "AZ",
            value: "AZ",
        },
        {
            key: "AR",
            value: "AR",
        },
        {
            key: "CA",
            value: "CA",
        },
        {
            key: "CO",
            value: "CO",
        },
        {
            key: "CT",
            value: "CT",
        },
        {
            key: "DE",
            value: "DE",
        },
        {
            key: "FL",
            value: "FL",
        },
        {
            key: "GA",
            value: "GA",
        },
        {
            key: "HI",
            value: "HI",
        },
        {
            key: "ID",
            value: "ID",
        },
        {
            key: "IL",
            value: "IL",
        },
        {
            key: "IN",
            value: "IN",
        },
        {
            key: "IA",
            value: "IA",
        },
        {
            key: "KS",
            value: "KS",
        },
        {
            key: "KY",
            value: "KY",
        },
        {
            key: "LA",
            value: "LA",
        },
        {
            key: "ME",
            value: "ME",
        },
        {
            key: "MD",
            value: "MD",
        },
        {
            key: "MA",
            value: "MA",
        },
        {
            key: "MI",
            value: "MI",
        },
        {
            key: "MN",
            value: "MN",
        },
        {
            key: "MS",
            value: "MS",
        },
        {
            key: "MO",
            value: "MO",
        },
        {
            key: "MT",
            value: "MT",
        },
        {
            key: "NE",
            value: "NE",
        },
        {
            key: "NV",
            value: "NV",
        },
        {
            key: "NH",
            value: "NH",
        },
        {
            key: "NJ",
            value: "NJ",
        },
        {
            key: "NY",
            value: "NY",
        },
        {
            key: "NM",
            value: "NM",
        },
        {
            key: "NC",
            value: "NC",
        },
        {
            key: "ND",
            value: "ND",
        },
        {
            key: "OH",
            value: "OH",
        },
        {
            key: "OK",
            value: "OK",
        },
        {
            key: "OR",
            value: "OR",
        },
        {
            key: "PA",
            value: "PA",
        },
        {
            key: "RI",
            value: "RI",
        },
        {
            key: "SC",
            value: "SC",
        },
        {
            key: "SD",
            value: "SD",
        },
        {
            key: "TN",
            value: "TN",
        },
        {
            key: "TX",
            value: "TX",
        },
        {
            key: "UT",
            value: "UT",
        },
        {
            key: "VT",
            value: "VT",
        },
        {
            key: "WA",
            value: "WA",
        },
        {
            key: "WV",
            value: "WV",
        },
        {
            key: "WI",
            value: "WI",
        },
        {
            key: "WY",
            value: "WY",
        }
        ],
        required: false
      },
      {
        id: 'mailing_postcode',
        label: 'Zipcode',
        type: 'text',
        control_name: 'mailing_postcode',
        required: false,
        maxlength: 5,
        pattern: '^[0-9]+$'
      }
    ]
  },
  {
    id: 5,
    name: 'Other Details',
    fields: [
      {
        id: 'extra2',
        label: 'Personal ID(PID)',
        type: 'text',
        control_name: 'extra2',
        required: true,
        maxlength: 50,
        pattern: '^[0-9]+$'
      },
      {
        id: 'extra3',
        label: 'SIS ID',
        type: 'text',
        control_name: 'extra3',
        required: false,
        maxlength: 50,
        pattern: '^[0-9]+$'
      },
      {
        id: 'SSN4',
        label: 'Last 4 Of Social',
        type: 'text',
        control_name: 'SSN4',
        required: false,
        maxlength: 4,
        pattern: '^[0-9]+$'
      },
      {
        id: 'medicaid_number',
        label: 'Medicaid',
        type: 'text',
        control_name: 'medicaid_number',
        required: false,
        maxlength: 50,
        pattern: '^.*$'
      }
    ]
  },
  {
    id: 6,
    name: 'Additional Details',
    fields: [
      {
        id: 'home_county',
        label: 'County',
        type: 'select',
        control_name: 'home_county',
        options: [
          { key: '1', value: 'Mecklenburg' },
          { key: '2', value: 'Gaston' },
          { key: '3', value: 'Pender' },
          { key: '4', value: 'Union' }
        ],
        required: true,
      },
      {
        id: 'race',
        label: 'Race',
        type: 'text',
        control_name: 'race',
        required: false,
        maxlength: 50,
        pattern: '^[a-zA-Z]+$'
      },
      {
        id: 'ethnicity',
        label: 'Ethnicity',
        type: 'text',
        control_name: 'ethnicity',
        required: false,
        maxlength: 50,
        pattern: '^[a-zA-Z]+$'
      },
      {
        id: 'marital_status',
        label: 'Marital Status',
        type: 'text',
        control_name: 'marital_status',
        required: false,
        maxlength: 50,
        pattern: '^[a-zA-Z]+$'
      },
      {
        id: 'preferred_language',
        label: 'Preferred Language',
        type: 'text',
        control_name: 'preferred_language',
        required: false,
        maxlength: 50,
        pattern: '^[a-zA-Z]+$'
      }
    ]
  },
  {
    id: 7,
    name: 'Primary Emergency Contact',
    fields: [
      {
        id: 'emergency_contact',
        label: 'Name',
        type: 'text',
        control_name: 'emergency_contact',
        required: false,
        maxlength: 50,
        pattern: '^.*$'
      },
      {
        id: 'emergency_phone_day',
        label: 'Primary Phone Number',
        type: 'text',
        control_name: 'emergency_phone_day',
        required: false,
        maxlength: 12,
        pattern: '^\\d{3}-\\d{3}-\\d{4}$'
      }
    ]
  }
];